// extracted by mini-css-extract-plugin
export default {"betaBadge":"C3tiLvvgwuM5I74nV5Np"};